import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';

@Directive({
  selector: '[appKeyboardFocus]'
})
export class KeyboardFocusDirective implements OnInit {

  @Input() scrollOffset: number = 100; // Offset adicional para el scroll

  constructor(
    private el: ElementRef,
    private platform: Platform
  ) {}

  ngOnInit() {
    // Solo aplicar en dispositivos móviles
    if (!this.platform.is('mobile')) {
      return;
    }
  }

  @HostListener('focus')
  onFocus() {
    if (this.platform.is('android') || this.platform.is('ios')) {
      this.handleInputFocus();
    }
  }

  @HostListener('blur')
  onBlur() {
    if (this.platform.is('android') || this.platform.is('ios')) {
      this.handleInputBlur();
    }
  }

  private async handleInputFocus() {
    try {
      // Esperar un poco para que el teclado aparezca
      setTimeout(() => {
        this.scrollToElement();
      }, 600); // Aumentamos el tiempo para dar más tiempo al teclado
    } catch (error) {
      console.error('Error manejando foco del input:', error);
    }
  }

  private async handleInputBlur() {
    try {
      // No necesitamos hacer nada en blur por ahora
    } catch (error) {
      console.error('Error manejando blur del input:', error);
    }
  }

  private scrollToElement() {
    try {
      const element = this.el.nativeElement;

      // Hacer scroll suave al elemento
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });
    } catch (error) {
      console.error('Error haciendo scroll al elemento:', error);
    }
  }
}
